import Store from "../util/store"
import protocolSender from "../util/protocol-sender"

const OPEN_UPLOAD_RES = 'open_upload_res'

class UploadManager {
  constructor (params) {
    // 开始上传
    this.startUpload_hook = params.onStartUpload || function () {}
    // 开始转码
    this.startTransCode_hook = params.onStartTransCode || function () {}
    // 转码成功
    this.transCodeSuccess_hook = params.onTransCodeSuccess || function () {}

    this.failed_hook = params.onFiled || function () {}

    this.file = params.file
    this.filename = params.file_name
    this.size = params.file_size
    this.upload_mode = params.upload_mode || 0

    this.convert_file_path = null
    this.file_path = null
    
    Store.msgDispatcher.addMsgHandler(20001, this._onRecvOpenUploadMsg.bind(this));
    Store.msgDispatcher.addMsgHandler(20003, this._onRecvCloseUploadMsg.bind(this));
    Store.msgDispatcher.addMsgHandler(21001, this._onRecvTransCodeMsg.bind(this));
  }
  startUpload () {
    this.startUpload_hook.call(this)
    protocolSender.sendOpenUpload({
      filename: this.filename,
      size: this.size
    })
  }
  /**
   * 开始上传响应消息
   * @param {*} data 
   */
  _onRecvOpenUploadMsg (data) {
    if (data.code === 0) {
      this.file_path = data.data.file_path
      let url = data.data.url.replace('http:', 'https:')
      this.uploadFile(url).then((resp) => {
        protocolSender.sendUploadEnd(this.file_path)
      }).catch(() => {
        this.failed_hook.call(this, {
          code: -1,
          msg: '上传失败'
        })
      }) 
    } else {
      this.failed_hook.call(this, {
        code: -1,
        msg: data.msg
      })
    }
  }
  /**
   * 上传结束响应消息
   */
  _onRecvCloseUploadMsg (data) {
    if (data.code === 0) {
      this.startTransCode_hook.call(this)
      protocolSender.sendTransCodeMsg(this.file_path)
    } else {
      this.failed_hook({
        code: -1,
        msg: data.msg
      })
    }
  }
  /**
   * 转码响应消息
   */
  _onRecvTransCodeMsg (data) {
    if (data.code === 0) {
      data = data.data
      this.transCodeSuccess_hook.call(this, {
        board_name: this.filename,
        convert_file_path: data.convert_file_path,
        file_path: data.file_path,
        width: data.width,
        height: data.height,
        page: data.convert_counts
      })
    } else {
      this.failed_hook.call(this, {
        code: -1,
        msg: data.msg
      })
    }
  }
  uploadFile (url) {
    let formData = new FormData()
    formData.append('file', this.file)
    return fetch(url, {
      method: 'put',
      headers: {
        'Content-Type': ''
      },
      body: this.file
      // credentials: 'omit'
    })
  }
}


// function getQueryString(name, str) {
//   var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
//   var r = str.substr(1).match(reg);
//   if (r != null) {
//   return unescape(r[2]);
//   }
//   return null;
// }
export default UploadManager